import React, { Fragment, useEffect, useState, useCallback } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";

import Contributors from "./screens/Contributors";
import Reports from "./screens/Reports";
import { GeneralAdminRoutes, routes } from "./constants";
import Logout from "./screens/Logout";
import QuickTaleDetails from "./screens/QuickTaleDetails/QuickTaleDetails";
import QuickTalesInOrganization from "./screens/QuicktalesInOrg/QuickTalesInOrganization";
import CreateQuickTaleContainer from "./modules/OrganizationQuickTales/containers/CreateQuickTaleContainer/CreateQuickTaleContainer";
import ReactionsInOrg from "./screens/ReactionsInOrg/ReactionsInOrg";
import Dashboard from "./screens/Dashboard/Dashboard";
import AlbumsInOrg from "./screens/AlbumsInOrg/AlbumsInOrg";
import AlbumDetails from "./screens/AlbumDetails/AlbumDetails";
import AddQuickTalesToAlbumContainer from "./modules/OrganizationAlbums/containers/AddQuickTalesToAlbumContainer/AddQuickTalesToAlbumContainer";
import AddQuicktalesToOrg from "./screens/AddQuicktalesToOrg/AddQuicktalesToOrg";
import AddQuicktalesToOrgDetails from "./screens/AddQuicktalesToOrgDetails/AddQuicktalesToOrgDetails";
import Admins from "./screens/Admins/Admins";
import AdminDetails from "./screens/AdminDetails/AdminDetails";
import AddAdmin from "./screens/AddAdmin/AddAdmin";
import OrgProf from "./screens/OrgProf";
import AreaManagement from "./screens/AreaManagement/AreaManagement";
import AreaDetails from "./screens/AreaDetails/AreaDetails";
import LoginPage from "./screens/Login";
import ForgotPassword from "./screens/ForgotPassword";
import AreaDetailsAddQTToArea from "./screens/AreaDetailsAddQTToArea/AreaDetailsAddQTToArea";
import AreaManagementAddArea from "./screens/AreaManagementAddArea/AreaManagementAddArea";

import ProtectedRoute from "./ProtectedRoute";
import { useAuth } from "./hooks";
import AddContributor from "./modules/Contributors/containers/AddContributorContainer";
import GADashboard from "./GeneralAdmin/screens/GADashboard/GADashboard";
import GAUsers from "./GeneralAdmin/screens/GAUsers/GAUsers";
import GAUserDetails from "./GeneralAdmin/screens/GAUserDetails/GAUserDetails";
import GAQuickTales from "./GeneralAdmin/screens/GAQuickTales/GAQuickTales";
import GAReactions from "./GeneralAdmin/screens/GAReactions/GAReactions";
import GAReactionDetails from "./GeneralAdmin/screens/GAReactionsDetails/GAReactionDetails";
import GAOrganizations from "./GeneralAdmin/screens/GAOrganizations/GAOrganizations";
import GAAdminUsers from "./GeneralAdmin/screens/GAAdminUsers/GAAdminUsers";
import GAAdminUsersDetails from "./GeneralAdmin/screens/GAAdminUsersDetails/GAAdminUsersDetails";
import GAThirdPartyTools from "./GeneralAdmin/screens/GAThirdPartyTools/GAThirdPartyTools";
import GAListenFeedSettings from "./GeneralAdmin/screens/GAListenFeedSettings/GAListenFeedSettings";
import GAAppVersionSettings from "./GeneralAdmin/screens/GAAppVersionSettings/GAAppVersionSettings";
import GAQCTemplate from "./GeneralAdmin/screens/GAQCTemplate/GAQCTemplate";
import GAEmailTemplates from "./GeneralAdmin/screens/GAEmailTemplates/GAEmailTemplates";
import GAEmailTemplateDetails from "./GeneralAdmin/screens/GAEmailTemplateDetails/GAEmailTemplateDetails";
import GASalesPages from "./GeneralAdmin/screens/GASalesPages/GASalesPages";
import GASalesPageSection from "./GeneralAdmin/screens/GASalesPageSection/GASalesPageSection";
import GASalesPagesList from "./GeneralAdmin/screens/GASalesPagesList/GASalesPagesList";
import GASalesUploads from "./GeneralAdmin/screens/GASalesUploads/GASalesUploads";
import GASalesContactSubmissions from "./GeneralAdmin/screens/GASalesContactSubmissions/GASalesContactSubmissions";
import GASalesPageEdit from "./GeneralAdmin/screens/GASalesPageEdit/GASalesPageEdit";
import GAQuickTaleDetails from "./GeneralAdmin/screens/GAQuickTaleDetails/GAQuickTaleDetails";
import GAOrganizationDetails from "./GeneralAdmin/screens/GAOrganizationDetails/GAOrganizationDetails";
import GACreateQuickTaleContainer from "./GeneralAdmin/modules/GAQuickTales/containers/GACreateQuickTaleContainer/GACreateQuickTaleContainer";
import GAReports from "./GeneralAdmin/screens/GAReports/GAReports";
import GAContentModeration from "./GeneralAdmin/screens/GAContentModeration/GAContentModeration";
import GALogin from "./GeneralAdmin/screens/GALogin/GALogin";
import AcceptAdminInvite from "./screens/EmailInvite/AcceptAdminInvite";
import AddAlbum from "./screens/AddAlbum/AddAlbum";
import GAContentModerationDetails from "./GeneralAdmin/screens/GAContentModerationDetails/GAContentModerationDetails";
import GAUserProfile from "./GeneralAdmin/screens/GAUserProfile/GAUserProfile";

import { Backdrop, CircularProgress } from "@mui/material";
import AddGAAdminUser from "./GeneralAdmin/screens/AddGAAdminUser/AddGAAdminUser";
import GAAddOrganization from "./GeneralAdmin/screens/GAAddOrganization/GAAddOrganization";
import AcceptContributorInvite from "./screens/EmailInvite/AcceptContributorInvite";
import GAAlbums from "./GeneralAdmin/screens/GAAlbums/GAAlbums";
import AddAlbumsToArea from "./screens/AddAlbumsToArea/AddAlbumsToArea";
import AddQuickTalesToGAAlbum from "./GeneralAdmin/screens/AddQuickTalesToGAAlbum/AddQuickTalesToGAAlbum";
import GAAlbumDetails from "./GeneralAdmin/screens/GAAlbumDetails/GAAlbumDetails";
import AddGAAlbum from "./GeneralAdmin/screens/AddGAAlbum/AddGAAlbum";
import GAGroups from "./GeneralAdmin/screens/GAGroups/GAGroups";
import GAGroupDetails from "./GeneralAdmin/screens/GAGroupDetails/GAGroupDetails";
import GAAddMembersToGroup from "./GeneralAdmin/screens/GAAddMembersToGroup/GAAddMembersToGroup";
import GAAddQuickTalesToGroup from "./GeneralAdmin/screens/GAAddQuickTalesToGroup/GAAddQuickTalesToGroup";
import GAAddGroup from "./GeneralAdmin/screens/GAAddGroup/GAAddGroup";
import AdminUserProfile from "./screens/AdminUserProfile/AdminUserProfile";
import Help from "./screens/Help";
import Notifications from "./screens/Notifications/Notifications";
import EmailTemplates from "./screens/EmailTemplates/EmailTemplates";
import EmailTemplateDetailsContainer from "./modules/OrganizationEmailTemplates/containers/EmailTemplateDetailsContainer/EmailTemplateDetailsContainer";
import StandardEmailTemplatesContainer from "./modules/OrganizationEmailTemplates/containers/StandardEmailTemplatesContainer/StandardEmailTemplatesContainer";
import QCTemplateDetailsContainer from "./modules/OrganizationQCTemplates/containers/QCTemplateDetailsContainer/QCTemplateDetailsContainer";
import Batches from "./screens/Batches/Batches";
import BatchDetails from "./screens/BatchDetails/BatchDetails";
import BatchQuickTaleDetails from "./screens/BatchQuickTaleDetails/BatchQuickTaleDetails";
import {
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { auth } from "./firebase";
import ActivityMonitor from "./common/ActivityMonitor";
import AddToQuickTaleContainer from "./modules/OrganizationQuickTales/containers/AddToQuickTaleContainer/AddToQuickTaleContainer";
import QuickCollectContainer from "./modules/QuickCollect/containers/QuickCollectContainer/QuickCollectContainer";
import GuestContributors from "./screens/GuestContributors/GuestContributors";
import GAClassroomAudioReactions from "./GeneralAdmin/screens/GAClassroomAudioReactions/GAClassroomAudioReactions";
import GAClassroomAudioReactionDetails from "./GeneralAdmin/screens/GAClassroomAudioReactionDetails/GAClassroomAudioReactionDetails";
import OrganizationDashboard from "./screens/OrganizationDashboard/OrganizationDashboard";
import Home from "./screens/Home/Home";

function App() {
  const { isLoggedIn, currentUser, currentLayoutAccess, onLogout, authInitialized } = useAuth();
  const [routeType, setRouteType] = useState(null);
  const [userLoading, setUserLoading] = useState(true);
  const [deepLinkCaptured, setDeepLinkCaptured] = useState(false);
  const [authProcessed, setAuthProcessed] = useState(false);
  const navigate = useNavigate();

  // IMMEDIATE deep link capture - runs once on mount
  useEffect(() => {
    // This should only run once on initial mount
    if (deepLinkCaptured) return;
    
    console.log('=== IMMEDIATE DEEP LINK CAPTURE ===');
    const queryParams = new URLSearchParams(window.location.search);
    const redirectUrl = queryParams.get('redirectUrl');
    
    // Determine final destination route immediately
    // If there's a deep link, use it; otherwise use the current pathname
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    const fullPath = `${currentPath}${currentSearch}`;
    const finalRoute = redirectUrl || fullPath || '/home';
    console.log('Final route determined:', finalRoute);
    
    // Store the final route (either deep link or current path)
    sessionStorage.setItem('finalRoute', finalRoute);
    localStorage.setItem('finalRoute', finalRoute);
    
    if (redirectUrl) {
      console.log('Deep link found on mount:', redirectUrl);
      // Clean the URL
      queryParams.delete('redirectUrl');
      const newUrl = `${window.location.pathname}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      window.history.replaceState({}, document.title, newUrl);
      console.log('URL cleaned, final route stored');
    } else {
      console.log('No deep link, using current path:', currentPath);
    }
    
    setDeepLinkCaptured(true);
    console.log('=== END IMMEDIATE DEEP LINK CAPTURE ===');
  }, []); // Empty dependency array - runs only once

  // Handle route changes for authenticated users
  const handleRouteChange = useCallback(() => {
    const noRedirectPaths = [
      "/accept-admin-invite",
      "/accept-contributor-invite",
    ];

    let currentPath = window.location.pathname;
    const getBasePath = (path) => {
      const segments = path.split("/");
      return segments.length > 1 ? `/${segments[1]}` : "/";
    };

    const basePath = getBasePath(currentPath);

    if (noRedirectPaths.includes(basePath)) {
      if (isLoggedIn) {
        onLogout();
      }
      return;
    }

    setRouteType(
      currentUser?.type === "organization"
        ? routes.dashboard
        : currentLayoutAccess === "organization"
        ? routes.dashboard
        : GeneralAdminRoutes.dashboard
    );
  }, [isLoggedIn, onLogout, currentUser, currentLayoutAccess]);

  // Set userLoading to false when auth is initialized
  useEffect(() => {
    if (authInitialized) {
      setUserLoading(false);
    }
  }, [authInitialized]);

  // Session management
  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem(
        "lastActivityTime",
        new Date().getTime().toString()
      );

      if (localStorage.getItem("user")) {
        localStorage.setItem("sessionEnded", "false");
      }
    };

    const handleUnload = () => {
      const lastActivityTime = parseInt(
        sessionStorage.getItem("lastActivityTime"),
        10
      );
      const currentTime = new Date().getTime();
      const timeDifference = currentTime - lastActivityTime;

      if (timeDifference < 1000) {
        return; // Page refresh detected
      }

      localStorage.setItem("sessionEnded", "true");
      onLogout();
    };

    sessionStorage.setItem("lastActivityTime", new Date().getTime().toString());
    localStorage.setItem("sessionEnded", "false");

    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("unload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("unload", handleUnload);
    };
  }, [onLogout]);

  if (userLoading) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={true}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }

  return (
    <Fragment>
      <ActivityMonitor>
        <div id="notification" className="notification"></div>
        <Routes>
            <Route
              path="/addtoquicktale"
              element={<AddToQuickTaleContainer />}
            />
            {/*
              QuickCollect public guest submission form.
              Three-segment path, so it cannot shadow the 1-2 segment admin
              routes below. See docs/QUICKCOLLECT_IMPLEMENTATION.md
            */}
            <Route
              path={routes.quickCollectSubmit}
              element={<QuickCollectContainer />}
            />
            <Route
              element={
                <ProtectedRoute isAllowed={!isLoggedIn} redirectUrl={routeType} />
              }
            >
              <Route exact path={routes.login} element={<LoginPage />} />
              <Route
                exact
                path={routes.forgotPassword}
                element={<ForgotPassword />}
              />
              <Route
                exact
                path={routes.inviteContributors}
                element={<AcceptContributorInvite />}
              />
              <Route
                exact
                path={routes.inviteAdmin}
                element={<AcceptAdminInvite />}
              />
            </Route>
            {/* General Admin Routes start */}
            <Route element={<ProtectedRoute isAllowed={isLoggedIn} />}>
              <Route
                exact
                path={GeneralAdminRoutes.dashboard}
                element={<GADashboard />}
              />
              <Route exact path={GeneralAdminRoutes.users} element={<GAUsers />} />
              <Route
                exact
                path={GeneralAdminRoutes.reactions}
                element={<GAReactions />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.albums}
                element={<GAAlbums />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.groups}
                element={<GAGroups />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.albumDetails}
                element={<GAAlbumDetails />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.groupDetails}
                element={<GAGroupDetails />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.addGAAlbum}
                element={<AddGAAlbum />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.addGroup}
                element={<GAAddGroup />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.addMembersToGroup}
                element={<GAAddMembersToGroup />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.addQuickTalesToGroup}
                element={<GAAddQuickTalesToGroup />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.addQTsToGAAlbum}
                element={<AddQuickTalesToGAAlbum />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.userDetails}
                element={<GAUserDetails />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.reactionDetails}
                element={<GAReactionDetails />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.quicktales}
                element={<GAQuickTales />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.quicktaleDetails}
                element={<GAQuickTaleDetails />}
              />
              <Route
                exact
                path="/general-admin/quicktales/create"
                element={<GACreateQuickTaleContainer />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.organizations}
                element={<GAOrganizations />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.addOrganization}
                element={<GAAddOrganization />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.organizationDetails}
                element={<GAOrganizationDetails />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.adminUsers}
                element={<GAAdminUsers />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.addAdminUser}
                element={<AddGAAdminUser />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.adminUserDetails}
                element={<GAAdminUsersDetails />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.thirdPartyTools}
                element={<GAThirdPartyTools />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.listenFeedSettings}
                element={<GAListenFeedSettings />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.appVersionSettings}
                element={<GAAppVersionSettings />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.qcDefaultTemplate}
                element={<GAQCTemplate />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.genEmailTemplates}
                element={<GAEmailTemplates />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.genEmailTemplateDetails}
                element={<GAEmailTemplateDetails />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.createGenEmailTemplate}
                element={<GAEmailTemplateDetails />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.salesPagesList}
                element={<GASalesPagesList />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.salesUploads}
                element={<GASalesUploads />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.salesContactSubmissions}
                element={<GASalesContactSubmissions />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.salesPageAdd}
                element={<GASalesPageEdit />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.salesPageEdit}
                element={<GASalesPageEdit />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.salesPageContent}
                element={<GASalesPages />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.salesPageSectionAdd}
                element={<GASalesPageSection />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.salesPageSectionEdit}
                element={<GASalesPageSection />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.reports}
                element={<GAReports />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.contentModeration}
                element={<GAContentModeration />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.contentModerationDetails}
                element={<GAContentModerationDetails />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.classroomAudioReactions}
                element={<GAClassroomAudioReactions />}
              />
              <Route
                exact
                path={GeneralAdminRoutes.classroomAudioReactionDetails}
                element={<GAClassroomAudioReactionDetails />}
              />
              <Route exact path={GeneralAdminRoutes.logout} element={<GALogin />} />
              <Route
                exact
                path={GeneralAdminRoutes.userProfile}
                element={<GAUserProfile />}
              />
            </Route>
            {/* General Admin Routes end */}

            {/* Organization Admin Routes start */}
            <Route element={<ProtectedRoute isAllowed={isLoggedIn} />}>
              <Route
                exact
                path={routes.dashboard}
                element={<Home />}
              />
              <Route
                exact
                path={routes.addQuicktalesToOrg}
                element={<AddQuicktalesToOrg />}
              />
              <Route
                exact
                path={routes.addQuicktalesToOrgDetails}
                element={<AddQuicktalesToOrgDetails />}
              />
              <Route exact path={routes.admins} element={<Admins />} />
              <Route exact path={routes.adminDetails} element={<AdminDetails />} />
              <Route exact path={routes.addAdmin} element={<AddAdmin />} />
              <Route exact path={routes.albumsInOrg} element={<AlbumsInOrg />} />
              <Route
                exact
                path={routes.orgProfileManagement}
                element={<OrgProf />}
              />
              <Route exact path={routes.help} element={<Help />} />
              <Route exact path={routes.notifications} element={<Notifications />} />
              <Route exact path={routes.emailTemplates} element={<EmailTemplates />} />
              <Route
                exact
                path={routes.emailTemplateDetails}
                element={<EmailTemplateDetailsContainer />}
              />
              <Route
                exact
                path={routes.createEmailTemplate}
                element={<EmailTemplateDetailsContainer />}
              />
              <Route
                exact
                path={routes.standardEmailTemplates}
                element={<StandardEmailTemplatesContainer />}
              />
              <Route
                exact
                path={routes.standardEmailTemplateDetails}
                element={<EmailTemplateDetailsContainer scope="gen" readOnly />}
              />
              <Route
                exact
                path={routes.qcTemplateDetails}
                element={<QCTemplateDetailsContainer />}
              />
              <Route exact path={routes.batches} element={<Batches />} />
              <Route
                exact
                path={routes.guestContributors}
                element={<GuestContributors />}
              />
              <Route exact path={routes.batchDetails} element={<BatchDetails />} />
              <Route
                exact
                path={routes.batchQuicktaleDetails}
                element={<BatchQuickTaleDetails />}
              />
              <Route
                exact
                path={routes.userProfile}
                element={<AdminUserProfile />}
              />
              <Route exact path={routes.login} element={<LoginPage />} />
              <Route
                exact
                path={routes.albumInOrgDetails}
                element={<AlbumDetails />}
              />
              <Route exact path={routes.addAlbum} element={<AddAlbum />} />
              <Route
                exact
                path={routes.addQuickTalesToAlbum}
                element={<AddQuickTalesToAlbumContainer />}
              />
              <Route
                exact
                path={routes.areaManagement}
                element={<AreaManagement />}
              />
              <Route exact path={routes.areaDetails} element={<AreaDetails />} />
              <Route
                exact
                path={routes.addArea}
                element={<AreaManagementAddArea />}
              />
              <Route
                exact
                path={routes.addContributor}
                element={<AddContributor />}
              />
              <Route exact path={routes.areaDetails} element={<AreaDetails />} />
              <Route
                exact
                path={routes.addQTToArea}
                element={<AreaDetailsAddQTToArea />}
              />
              <Route
                exact
                path={routes.addAlbumsToArea}
                element={<AddAlbumsToArea />}
              />
              <Route exact path={routes.contributors} element={<Contributors />} />
              <Route
                exact
                path={routes.quicktalesInOrg}
                element={<QuickTalesInOrganization />}
              />
              <Route
                exact
                path={routes.createQuickTale}
                element={<CreateQuickTaleContainer />}
              />
              <Route
                exact
                path={routes.quicktaleInOrgDetails}
                element={<QuickTaleDetails />}
              />
              <Route
                exact
                path={routes.reactionsInOrg}
                element={<ReactionsInOrg />}
              />
              <Route exact path={routes.reports} element={<Reports />} />
              <Route
                exact
                path={routes.organizationDashboard}
                element={<OrganizationDashboard />}
              />
              <Route exact path={routes.logout} element={<Logout />} />
              {/* Root route as fallback - must be last */}
              <Route exact path="/" element={<Home />} />
            </Route>
            {/* Organization Admin Routes end */}
          </Routes>
        </ActivityMonitor>
    </Fragment>
  );
}

export default App;
